import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FlagOutlinedSvg from "@ant-design/icons-svg/es/asn/FlagOutlined";
import AntdIcon from '../components/AntdIcon';
var FlagOutlined = function FlagOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: FlagOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(FlagOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'FlagOutlined';
}
export default RefIcon;